import React from 'react'
import NumberFormat from '../../../components/NumberFormat'

const Bnm = ({ cheque }) => {
    return (
        <tr className='ligne' >
            <td>
                <div id=''
                    className="relative overflow-hidden border border-gray-300 cheque-print"
                    style={{
                        width: '165mm',
                        height: '75mm',
                        backgroundImage: 'url(/bnm.jpg)',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center top'
                    }}
                >
                    {/* Montant (en haut à droite) */}
                    <div className="absolute font-times top-7 right-32 text-lg font-bold text-black">
                        <NumberFormat valeur={cheque.montant} />
                    </div>

                    {/* À l'ordre de */}
                    <div className="absolute font-times left-[39mm] top-[23mm] text-xs font-semibold">
                        {cheque.montantLettre.substring(0, 62)}
                    </div>

                    <div className="absolute font-times left-[40mm] top-[27mm] text-xs font-semibold">
                        {cheque.montantLettre.substring(62, 1000)}
                    </div>

                    {/* À l'ordre de */}
                    <div className="absolute font-times left-[23mm] top-[34mm] text-sm font-semibold">
                        {cheque.nom}
                    </div>

                    {/* Numéro de chèque */}
                    {/* <div className="absolute left-[48mm] top-[33mm] text-sm">

                            </div> */}

                    {/* Compte n° */}
                    {/* <div className="absolute left-[48mm] top-[38mm] text-sm">

                            </div> */}

                    {/* Lieu et date */}
                    <div className="absolute font-times left-[106mm] top-[40mm] text-xs font-semibold">
                        {cheque.lieu}
                    </div>
                    <div className="absolute font-times left-[137mm] top-[40mm] text-xs font-semibold">
                        {cheque.dateCheque}
                    </div>

                    {/* Signature */}
                    <div className="absolute font-times right-[23mm] bottom-[10mm] text-sm font-semibold">

                    </div>
                </div>
            </td>

        </tr>
    )
}

export default Bnm